import { EvaSource, TimeStep } from "constants/charts.enums";

export enum PdenSourceEnum {
  gDC = 0,
  enverus = 2,
  aer = 3,
  mcdan = 4,
  novi = 5,
  ihs = 8,
  Public = 100,
  Private = 101,
  Hybrid = 102
}

export interface PdenDataSourceSetting {
  source: EvaSource;
  timeStep: TimeStep;
  /** Per-chart override: restrict production data to one specific public source.
   *  Uses the DataSource proto enum's numeric value (e.g. gDC=0, McDan=4, Novi=5).
   *  Omit (or set undefined) to use all public sources — backward compatible.
   *  IMPORTANT: gDC == 0, so always check `!= null`, never truthiness. */
  specificPublicSource?: number;
}
